<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryBinStatusResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      with-custom-row-actions-first-column
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      importEnabled
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openTransfer()"
                                    >
                                        移库
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        :disabled="actionDisabled('selectOne')"
                                        @click="openCount()"
                                    >
                                        盘库
                                    </b-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        :disabled="actionDisabled('select')"
                                        @click="openChangeProject()"
                                    >
                                        创建转库
                                    </b-button>
                                    <b-button
                                            :disabled="actionDisabled('select')"
                                            custom-icon="fa fa-fw fa-lg fa-print"
                                            custom-label="打印物料码"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="printBinData()"
                                    >
                                        打印bin位信息
                                    </b-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <b-button
                                            variant="outline-primary"
                                            size="sm"
                                            @click="gotoCountRecord(customRowScope.row)"
                                        >
                                            盘库记录
                                        </b-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="移库" :visible.sync="transferDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearTransferForm'>
            <el-form :model="transferForm" ref="transferForm" label-width="100px" :rules="rules">
                <el-row type="flex" style="flex-wrap:wrap">
                    <el-form-item label="源BIN位" prop="currentBin">
                        <el-input v-model="transferForm.currentBin" style="width:200px">
                            <el-button slot="append" icon="el-icon-camera" @click="scanCurrentBin"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="物料" prop="material">
                        <el-input v-model="transferForm.material" style="width:200px">
                            <el-button slot="append" icon="el-icon-camera" @click="scanMaterial"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="SO号" prop="specialStockNumber">
                        <el-input v-model="transferForm.specialStockNumber" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="转移数量" prop="quantity">
                        <el-input v-model="transferForm.quantity" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="源容量" prop="sourceCapacity">
                        <el-input v-model="transferForm.sourceCapacity" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="目的BIN位" prop="destination">
                        <el-input v-model="transferForm.destination" style="width:200px">
                            <el-button slot="append" icon="el-icon-camera" @click="scanDestination"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="目的容量" prop="destinationCapacity">
                        <el-input v-model="transferForm.destinationCapacity" style="width:200px"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>

            <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body
                       @close="closeScannerDialog" :close-on-click-modal='false'>
                <qr-code-scanner ref="scanner" @getCodeData='getCodeData'>
                </qr-code-scanner>
            </el-dialog>

            <div slot="footer">
                <el-button @click="transferDialogVisible = false">取消</el-button>
                <el-button @click="confirmTransfer" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="盘库" :visible.sync="countDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearCountForm'>
            <el-form :model="countForm" ref="countForm" label-width="auto" :rules="countRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="实际数量" prop="quantity">
                            <el-input v-model="countForm.quantity"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" :offset="1">
                        <el-form-item label="已占容量" prop="strCapacity">
                            <el-input v-model="countForm.strCapacity"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer">
                <el-button @click="countDialogVisible = false">取消</el-button>
                <el-button @click="confirmCount" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <!-- 转库 -->
        <el-dialog title="创建转库" :visible.sync="changeProjectVisible" :close-on-click-modal='false' append-to-body
                   @close='clearChangeProject'>
            <el-form :model="changeProjectForm" ref="changeProjectForm" label-width="auto" :rules="changeRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="转库类型" prop="changeType">
                            <el-select v-model="changeProjectForm.changeType">
                                <el-option
                                    v-for="type in changeTypes"
                                    :key="type.value"
                                    :label="type.text"
                                    :value="type.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="目的地" prop="target">
                            <el-input v-model="changeProjectForm.target"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-table :data="changeProjectDetails" ref="detailsTable" style="width:100%" max-height="285px">
                <el-table-column label="物料号" fixed prop="material"></el-table-column>
                <el-table-column label="BIN位" prop="storageBin"></el-table-column>
                <el-table-column label="特殊库存" prop="specialStock"></el-table-column>
                <el-table-column label="特殊库存号" prop="specialStockNumber"></el-table-column>
                <el-table-column label="可用数量" prop="availableStock"></el-table-column>
                <el-table-column label="转库数量">
                    <template slot-scope="scope">
                        <el-input clearable v-model="scope.row.changeQuantity" size="small"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer">
                <el-button @click="changeProjectVisible = false">取消</el-button>
                <el-button @click="createChangeTask()" type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2021-07-06 17:27:43

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    components: {qrCodeScanner},
    name: "sithMesInventoryBinStatusListView",
    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            // 移库dialog是否显示
            transferDialogVisible: false,
            // 盘库dialog是否显示
            countDialogVisible: false,
            // 转库dialog是否显示
            changeProjectVisible: false,
            // 扫码框是否显示
            scannerVisible: false,
            // 移库FORM
            transferForm: {
                currentBin: '',
                currentStorageLocation: '',
                currentStorageType: '',
                material: '',
                quantity: '',
                sourceCapacity: '',
                destination: '',
                destinationStorageLocation: '',
                destinationStorageType: '',
                destinationCapacity: ''
            },
            // 盘库FORM
            countForm: {
                binId: '',
                quantity: '',
                strCapacity: ''
            },
            // 转库FORM
            changeProjectForm: {
                changeType: '',
                target: ''
            },
            // 转库明细
            changeProjectDetails: [],
            // 当前扫描类型:source-源BIN位码，destination-目的BIN位码，material-物料码
            scanType: '',
            rules: {
                currentBin: [{required: true, message: '请输入或扫码录入BIN位'}],
                material: [{required: true, message: '请输入或扫码录入物料码'}],
                quantity: [{required: true, message: '请输入转移数量'}],
                sourceCapacity: [{required: true, message: '请输入容量'}],
                destination: [{required: true, message: '请输入或扫码录入目的BIN位'}],
                destinationCapacity: [{required: true, message: '请输入容量'}]
            },
            countRules: {
                quantity: [{required: true, message: '请输入实际数量'}],
                strCapacity: [{required: true, message: '请输入已占数量'}]
            },
            changeRules: {
                changeType: [{required: true, message: '请选择转库类型'}],
                target: [{required: true, message: '请输入转库目的地'}]
            },
            changeTypes: [
                {value: '1', text: 'SO转SO'},
                {value: '2', text: 'WBS转SO'},
                {value: '3', text: 'SO转大库'},
                {value: '4', text: '大库转SO'},
                {value: '5', text: '大库转WBS'},
                {value: '6', text: '寄售转大库'},
                {value: '7', text: 'WBS转大库'},
                {value: '8', text: 'SO转WBS'},
                {value: '9', text: 'WBS转WBS'},
                {value: '10', text: '大库转供应商'},
            ]
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
        },
    },
    methods: {
        printBinData() {
            let url = `${this.entityBaseUrl}printBinData?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                    .then(response => {
                        this.$router.push({
                            name: "sithMesInventoryBinStatusPrint",
                            query: response.data,
                        });
                    })
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        openTransfer() {
            let row = this.$refs.emTable.rows.filter(r => {
                return r.id == this.checkedItems
            });
            this.transferForm.currentBin = row[0].storageBin;
            this.transferForm.material = row[0].material;
            this.transferForm.sourceCapacity = row[0].occupiedCapacity;
            this.transferForm.specialStockNumber = row[0].specialStockNumber;
            this.transferDialogVisible = true;
        },
        openCount() {
            this.countDialogVisible = true;
        },
        openChangeProject() {
            let arr = JSON.parse(JSON.stringify(this.checkedRows));
            this.changeProjectDetails = arr.map(row => {
                return Object.assign(row, {changeQuantity: 0});
            });
            this.changeProjectVisible = true;
        },
        clearTransferForm() {
            for (let key in this.transferForm) {
                this.transferForm[key] = '';
            }
            this.$refs["transferForm"].resetFields();
        },
        clearCountForm() {
            this.countForm.binId = '';
            this.countForm.quantity = '';
            this.countForm.strCapacity = '';
            this.$refs["countForm"].resetFields();
        },
        clearChangeProject() {
            this.changeProjectForm.changeType = '';
            this.changeProjectForm.target = '';
            this.changeProjectDetails = [];
        },
        closeScannerDialog() {
            this.$refs.scanner.closeCamera();
            this.$refs.scanner.resetOutputData();
            this.scannerVisible = false;
            this.scanType = '';
        },
        scanCurrentBin() {
            this.scanType = 'source';
            this.scannerVisible = true;
        },
        scanMaterial() {
            this.scanType = 'material';
            this.scannerVisible = true;
        },
        scanDestination() {
            this.scanType = 'destination';
            this.scannerVisible = true;
        },
        getCodeData(data) {
            this.scannerVisible = false;
            let self = this;
            let jsonObj;
            //检验二维码的数据格式
            try {
                jsonObj = JSON.parse(data);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }

            if (this.scanType === 'source') {
                this.setSourceBin(jsonObj);
            } else if (this.scanType === 'material') {
                this.setMaterial(jsonObj);
            } else {
                this.setDestination(jsonObj);
            }
        },
        setSourceBin(jsonObj) {
            let binCode = jsonObj['Storage Bin'];
            let storageType = jsonObj['Storage Type'];
            let storageLocation = jsonObj['Storage Location'];
            this.transferForm.currentBin = binCode;
            this.transferForm.currentStorageLocation = storageLocation;
            this.transferForm.currentStorageType = storageType;
            // let queryForm = {};
            // queryForm.storageBin = binCode;
            // queryForm.storageType = storageType;
            // queryForm.storageLoc = storageLocation;
            // let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/findBin`;
        },
        setMaterial(jsonObj) {
            let material = jsonObj['物料号'];
            this.transferForm.material = material;
        },
        setDestination(jsonObj) {
            let binCode = jsonObj['Storage Bin'];
            let storageType = jsonObj['Storage Type'];
            let storageLocation = jsonObj['Storage Location'];
            this.transferForm.destination = binCode;
            this.transferForm.destinationStorageType = storageType;
            this.transferForm.destinationStorageLocation = storageLocation;
        },
        // 确认移库
        confirmTransfer() {
            let self = this;
            // 先校验表单所有必填项
            self.$refs["transferForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/transferMaterial`
                    this.$_emApiMixin_post(url, self.transferForm)
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "移库成功",
                                    type: "success",
                                });
                            } else {
                                self.$message({
                                    message: `response.message`,
                                    type: "error",
                                });
                            }
                        }).finally(
                        () => {
                            self.transferDialogVisible = false;
                        }
                    );
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            });
        },
        confirmCount() {
            let self = this;
            self.countForm.binId = self.selectIds;
            // 先校验表单所有必填项
            self.$refs["countForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/countBin`
                    this.$_emApiMixin_post(url, self.countForm)
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "盘库成功",
                                    type: "success",
                                });
                            } else {
                                self.$message({
                                    message: `response.message`,
                                    type: "error",
                                });
                            }
                        }).finally(
                        () => {
                            self.countDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        }
                    );
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            });
        },
        createChangeTask() {
            let self = this;
            // 先校验表单所有必填项
            self.$refs["changeProjectForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryChangeMaterialProject")}/createChangeProjectTask?changeType=${self.changeProjectForm.changeType}&target=${self.changeProjectForm.target}`
                    this.$_emApiMixin_post(url, self.changeProjectDetails)
                        .then(response => {
                            if (response.status === 200) {
                                self.$message({
                                    message: "创建转库成功",
                                    type: "success",
                                });
                            } else {
                                self.$message({
                                    message: `response.message`,
                                    type: "error",
                                });
                            }
                        }).finally(
                        () => {
                            self.changeProjectVisible = false;
                        }
                    );
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            });
        },
        gotoCountRecord(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesInventoryCount"
                , {binIdFilter: row.id}
                , {binId: row.id}, false, {})
        },

    }
};
</script>
